import { cn } from "@/lib/utils.ts";
import { Skeleton } from "@/components/ui/skeleton.tsx";
import { Spinner } from "@/components/ui/spinner.tsx";

export function PageLoading({ rows = 6, className }: { rows?: number; className?: string }) {
  return (
    <div className={cn("space-y-6", className)} aria-busy="true" aria-live="polite">
      <div className="space-y-2">
        <Skeleton className="h-7 w-56" />
        <Skeleton className="h-4 w-80 max-w-full" />
      </div>
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {Array.from({ length: 4 }).map((_, i) => (
          <Skeleton key={i} className="h-24 rounded-xl" />
        ))}
      </div>
      <div className="surface divide-y overflow-hidden">
        {Array.from({ length: rows }).map((_, i) => (
          <div key={i} className="flex items-center gap-4 px-4 py-3">
            <Skeleton className="h-4 w-1/4" />
            <Skeleton className="h-4 w-1/3" />
            <Skeleton className="ml-auto h-4 w-16" />
          </div>
        ))}
      </div>
      <span className="sr-only">Loading page</span>
    </div>
  );
}

export function InlineLoading({ label = "Loading…", className, size = 16 }: { label?: string; className?: string; size?: number }) {
  return (
    <div className={cn("inline-flex items-center gap-2 text-sm text-muted-foreground", className)} role="status" aria-live="polite">
      <Spinner size={size} aria-hidden="true" />
      <span>{label}</span>
    </div>
  );
}

export function CenteredLoading({ label, className }: { label?: string; className?: string }) {
  return (
    <div className={cn("flex min-h-[200px] w-full items-center justify-center", className)}>
      <InlineLoading label={label} />
    </div>
  );
}
